import React, { Component } from 'react';
import { Alert, Modal, ModalBody, Form, FormGroup, Label, Row, Col, Input, Button, Card, CardHeader, CardBody, CardFooter, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import API from '~/API';
import serialize from 'form-serialize';
import Registro from './Registro';
import { Global } from '~/App';
import Turnstile from '~/components/Turnstile';
import { formatUrlDestino } from '~/Compact/PortalCompacto';

export default class Login extends Component {
    _isMounted = false;    
    constructor() {
        super();
        this.state = {
            errores: [],
            cargando: false,
            abreModalRegistro: false
        }
        this.captchaRef = React.createRef();
        this.pendingForm = null;
        this.toggleModalRegistro = this.toggleModalRegistro.bind(this);
        this.onCaptchaResolved = this.onCaptchaResolved.bind(this);
        this.onCaptchaError = this.onCaptchaError.bind(this);
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    safelySetState(params, callback = null){
        if(this._isMounted)
            this.setState(params, callback);
    }
    validarDatos(form) {
        var errores = [];
        if (!form.Mail) {
            errores.push("Debes indicar tu correo electrónico");
        }
        if (!form.Password) {
            errores.push("Debes indicar tu contraseña");
        }
        this.safelySetState({ errores });
        return _.isEmpty(errores);
    }
    Loguear(event) {
        event.preventDefault();
        var form = serialize(event.target, { hash: true });
        if (this.validarDatos(form)) {
            this.safelySetState({ cargando: true, errores: [] });
            this.pendingForm = form;
            if (this.captchaRef.current) {
                this.captchaRef.current.execute();
            }
        }
    }
    onCaptchaError() {
        this.pendingForm = null;
        this.safelySetState({ cargando: false });
    }
    onCaptchaResolved(token) {
        if (!token) return;
        const form = this.pendingForm;
        this.pendingForm = null;
        if (!form) return;

        form.Captcha = token;
        API.Call("Home/Login", form)
            .then(async response => {
                await API.SetHeaderBearer(response.token, response.expires);
                if (Global.isModoCompact && Global.isModoCompact() && Global.urlDestino) {
                    const dest = formatUrlDestino(Global.urlDestino, "sucursal", { authToken: response.token });
                    if (dest) {
                        window.location.href = dest;
                        return;
                    }
                }
                Global.setCargandoServicios();
                Global.setUsuario(response.user);
                var Servicios = await API.Call("Administra/Servicio/Listado");
                Global.setServicios(Servicios);
                this.safelySetState({ cargando: false });
            })
            .catch(error => {
                if (this.captchaRef.current) this.captchaRef.current.reset();
                this.safelySetState({ cargando: false, errores: [error] });
            });
    }
    toggleModalRegistro() {
        this.safelySetState({ abreModalRegistro: !this.state.abreModalRegistro });
    }
    render() {
        return (
            <Row className="login-wrapper">
                <Col sm="12">
                    <Card className="login-card">
                        <CardBody>
                            <Form onSubmit={this.Loguear.bind(this)}>
                                {_.map(this.state.errores, (e, i) => 
                                    <Alert key={i} color={"warning"}>
                                        {e} {(e||"").toString().indexOf("confirm") >= 0 && <Link to={"/reenviar"}>Reenviar correo de confirmación</Link>}
                                        {(e||"").toString().indexOf("bloqueada") >= 0 && <span> <Link to={"/recuperar"}>Restablecer contraseña para desbloquear ahora</Link></span>}
                                    </Alert>
                                )}
                                <FormGroup>
                                    <Label for="Mail">Correo Electrónico</Label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                             <InputGroupText>👤</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="email" name="Mail" id="Mail" placeholder="tu.correo@ejemplo.com" />
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Password">Contraseña</Label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>🔒</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="password" name="Password" id="Password" placeholder="••••••••" />
                                    </InputGroup>
                                </FormGroup>
                                <div className="text-right mb-4">
                                     {Global.isModoCompact && Global.isModoCompact() && Global.urlDestino ? (
                                         <a href={formatUrlDestino(Global.urlDestino, "#/recuperar")}>¿Olvidaste tu contraseña?</a>
                                     ) : (
                                         <Link to={"/recuperar"}>¿Olvidaste tu contraseña?</Link>
                                     )}
                                </div>
                                <Turnstile
                                    ref={this.captchaRef}
                                    size="invisible"
                                    sitekey={Global.apiKeyCaptcha}
                                    onChange={this.onCaptchaResolved}
                                    onErrored={this.onCaptchaError}
                                    onExpired={this.onCaptchaError}
                                />
                                <Button block size="lg" disabled={this.state.cargando} color="primary" type="submit">
                                    {this.state.cargando ? 'Ingresando...' : 'Ingresar'}
                                </Button>
                            </Form>
                        </CardBody>
                        <CardFooter className="login-footer">
                           <span>¿No tienes una cuenta?</span>
                           {Global.isModoCompact && Global.isModoCompact() && Global.urlDestino ? (
                               <a href={formatUrlDestino(Global.urlDestino, "#/registrate")} className="font-weight-bold ml-1">Regístrate aquí</a>
                           ) : (
                               <Link to={"/registrate"} className="font-weight-bold ml-1">Regístrate aquí</Link>
                           )}
                        </CardFooter>
                    </Card>
                </Col>
                 <Modal size={"lg"} scrollable wrapClassName="asyntec-portal-clientes" isOpen={this.state.abreModalRegistro} toggle={this.toggleModalRegistro}>
                    <ModalBody>
                        <Registro FuncionCerrar={this.toggleModalRegistro}/>
                    </ModalBody>
                </Modal>
            </Row>
        )
    }
}